import { issueEsignSsoTicket } from '@/api/sso'

const REDIRECT_STORAGE_KEY = 'cliqforms_esign_redirect_to'
const AUTO_LAUNCH_STORAGE_KEY = 'cliqforms_esign_auto_launch'

export function normalizeEsignRedirect(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
    return '/dashboard'
  }

  try {
    const baseUrl = window.location.origin
    const target = new URL(value, baseUrl)
    const isAuthRoute = target.pathname === '/login'
      || target.pathname === '/sso'
      || target.pathname.startsWith('/sso/')

    if (target.origin !== baseUrl || isAuthRoute) {
      return '/dashboard'
    }

    return `${target.pathname}${target.search}${target.hash}`
  } catch {
    return '/dashboard'
  }
}

export function storeEsignRedirectIntent(redirectTo) {
  sessionStorage.setItem(REDIRECT_STORAGE_KEY, normalizeEsignRedirect(redirectTo))
  sessionStorage.setItem(AUTO_LAUNCH_STORAGE_KEY, '1')
}

export function getPendingEsignRedirect() {
  return normalizeEsignRedirect(sessionStorage.getItem(REDIRECT_STORAGE_KEY) || '/dashboard')
}

export function hasPendingEsignAutoLaunch() {
  return sessionStorage.getItem(AUTO_LAUNCH_STORAGE_KEY) === '1'
}

export async function openEsign(redirectTo = getPendingEsignRedirect()) {
  const response = await issueEsignSsoTicket(normalizeEsignRedirect(redirectTo))
  const redirectUrl = response?.data?.data?.redirect_url

  if (!redirectUrl) {
    throw new Error('Missing eSign redirect URL.')
  }

  sessionStorage.removeItem(REDIRECT_STORAGE_KEY)
  sessionStorage.removeItem(AUTO_LAUNCH_STORAGE_KEY)
  window.location.replace(redirectUrl)
}

// CliqSign in a new tab, signed in, so the page here (and anything unsaved on it) stays open. The tab is
// opened before the ticket is asked for, so the browser doesn't block it as a pop-up.
export async function openEsignInNewTab(redirectTo) {
  const tab = window.open('', '_blank')
  try {
    const response = await issueEsignSsoTicket(normalizeEsignRedirect(redirectTo))
    const redirectUrl = response?.data?.data?.redirect_url
    if (!redirectUrl) throw new Error('Missing eSign redirect URL.')
    if (!tab) {
      window.location.assign(redirectUrl)
      return
    }
    tab.opener = null
    tab.location.href = redirectUrl
  } catch (error) {
    tab?.close()
    throw error
  }
}

export function clearEsignRedirectIntent() {
  sessionStorage.removeItem(REDIRECT_STORAGE_KEY)
  sessionStorage.removeItem(AUTO_LAUNCH_STORAGE_KEY)
}
